// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"536ce9b1","244":"d5381295","260":"2fb9d87d","332":"27083f45","384":"24a28362","787":"e7a7291c"}[chunkId] + ".chunk.js";
};